import PWAAuthenticationBridgeClient from "./PWAAuthenticationBridgeClient";
import NativeRuntimeAuthenticationBridgeClient from "./NativeRuntimeAuthenticationBridgeClient";

import PWAResponseDataBridgeClient from "./PWAResponseDataBridgeClient";
import NativeResponseDataBridgeClient from "./NativeResponseDataBridgeClient";

import PWAResponseSupportBridgeClient from "./PWAResponseSupportBridgeClient";

import PWARuntimeBridgeClient from "./PWARuntimeBridgeClient";
import NativeRuntimeBridgeClient from "./NativeRuntimeBridgeClient";

import PWAAssessmentPackageManagerClient from "./PWAAssessmentPackageManagerClient";

import ScreenRecordingBridgeClient from "./ScreenRecordingBridgeClient";

import PWAPreloadBridgeClient from "./PWAPreloadBridgeClient";
import type { IPreloadBridgeClient } from "./IPreloadBridgeClient";

export default function registerBridgeClients(angular: any) {
    if (typeof (window as any).jsBridgeAuthentication !== 'undefined') {        
        angular.module('assessmentFrontendServices')
            .service('AuthenticationBridgeClient', ['$signals', NativeRuntimeAuthenticationBridgeClient]);            
    } else if (('serviceWorker' in navigator)) {
        angular.module('assessmentFrontendServices')
            .service('AuthenticationBridgeClient', ['$signals', PWAAuthenticationBridgeClient]);
    } else {    
        throw new Error('No bridge client implementation for AuthenticationBridgeClient');
    }

    if (typeof (window as any).jsBridgeResponseData !== 'undefined') {        
        angular.module('assessmentFrontendServices')
            .service('ResponseDataBridgeClient', ['$signals', NativeResponseDataBridgeClient]);
    } else if (('serviceWorker' in navigator)) {
        angular.module('assessmentFrontendServices')
            .service('ResponseDataBridgeClient', ['$signals', 'TelemetryBeaconService', PWAResponseDataBridgeClient]);
    } else {    
        throw new Error('No bridge client implementation for ResponseDataBridgeClient');
    }

    if (typeof (window as any).jsBridgeRuntime !== 'undefined') {
        angular.module('assessmentFrontendServices')
            .service('RuntimeBridgeClient', ['$signals', NativeRuntimeBridgeClient]);
    } else if (('serviceWorker' in navigator)) {
        angular.module('assessmentFrontendServices')
            .service('RuntimeBridgeClient', ['$signals', 'Notification', '$timeout', 'ScreenRecordingBridgeClient', PWARuntimeBridgeClient]);
    } else {
        throw new Error('No bridge client implementation for RuntimeBridgeClient');
    }

    angular.module('assessmentFrontendServices')
        .service('AssessmentPackageManagerClient', ['$signals', PWAAssessmentPackageManagerClient]);

    angular.module('assessmentFrontendServices')
        .service('ScreenRecordingBridgeClient', ['$signals', ScreenRecordingBridgeClient]);

    // Register PreloadBridgeClient - only available in PWA mode (service worker)
    if (('serviceWorker' in navigator)) {
        angular.module('assessmentFrontendServices')
            .service('PreloadBridgeClient', [PWAPreloadBridgeClient]);
    } else {
        // For native mode, register a no-op implementation so injection doesn't fail
        angular.module('assessmentFrontendServices')
            .service('PreloadBridgeClient', [function(): IPreloadBridgeClient {
                return {
                    onStatusUpdate: () => {},
                    offStatusUpdate: () => {},
                    getState: () => 'idle',
                    getStatus: () => null,
                    startPreload: () => {},
                    forceRefresh: () => {},
                    ensureBundles: () => {},
                    activateForSchool: () => {},
                    requestStatus: () => {}
                };
            }]);
    }

    // Register ResponseSupportBridgeClient - only available in PWA mode (service worker)
    if (('serviceWorker' in navigator)) {
        angular.module('assessmentFrontendServices')
            .service('ResponseSupportBridgeClient', [PWAResponseSupportBridgeClient]);
    } else {
        // For native mode, we could create a no-op implementation or throw an error
        // For now, we'll create a simple no-op implementation
        const notAvailable = () => Promise.reject(new Error("ResponseSupportBridgeClient not available in native mode"));
        const noop = () => {};
        angular.module('assessmentFrontendServices')
            .service('ResponseSupportBridgeClient', [function() {
                return {
                    listAllResponses: notAvailable,
                    getResponseDataJson: notAvailable,
                    listPendingRecoveries: notAvailable,
                    retryPendingRecovery: notAvailable,
                    retryAllPendingRecoveries: notAvailable,
                    deletePendingRecovery: notAvailable,
                    getPendingRecoveryCount: () => Promise.resolve(0),
                    addRetrySuccessListener: noop,
                    removeRetrySuccessListener: noop,
                    addRetryFailedListener: noop,
                    removeRetryFailedListener: noop,
                };
            }]);
    }
}
